import { Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { Rubric, RubricLevel } from '@mira-avant/mtlibs';
import { CommonModule } from '@angular/common';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { RouterModule } from '@angular/router';
import { RubricService } from '../../../../services/rubric.service';
import { ZorroModule } from '../../../../modules/zorro.module';

@Component({
	selector: 'app-rubric-levels-table',
	standalone: true,
	imports: [CommonModule, NzTableModule, NzButtonModule, NzTypographyModule, RouterModule, ZorroModule],
	templateUrl: './rubric-levels-table.component.html',
	styleUrl: './rubric-levels-table.component.scss',
})
export class RubricLevelsTableComponent implements OnInit, OnDestroy, OnChanges {
	@Input('rubric') public rubric: Rubric | undefined | null;

	public rubricLevels = signal<RubricLevel[]>([]);
	public loading = signal<boolean>(false);

	private subscriptions: Subscription = new Subscription();

	constructor(public rubricService: RubricService) {
		this.subscriptions.add(
			this.rubricService.loading$.subscribe(isLoading => {
				this.loading.set(isLoading);
			})
		);
	}

	ngOnInit(): void {
		this.subscriptions.add(
			this.rubricService.rubricLevels$.subscribe(levels => {
				if (this.rubric?.code) {
					this.rubricLevels.set(levels.filter(level => level.rubric_code === this.rubric!.code));
				} else {
					this.rubricLevels.set([]);
				}
			})
		);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['rubric'] && this.rubric?.code) {
			this.rubricService.getRubricLevels$(this.rubric.code).catch(error => {
				console.warn('No rubric levels found:', error);
				this.rubricLevels.set([]);
			});
		} else if (changes['rubric'] && !this.rubric?.code) {
			this.rubricLevels.set([]);
		}
	}

	public async deleteRubricLevel(uuid: string): Promise<void> {
		try {
			await this.rubricService.deleteRubricLevel$(uuid);
		} catch (error) {
			console.error('Error deleting rubric level:', error);
		}
	}

	public selectRubricLevel(rubricLevel: RubricLevel | undefined): void {
		this.rubricService.selectRubricLevel(rubricLevel);
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
